import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';

import { CreateEmailTemplate, EditEmailTemplates } from './email-templates';

export const EmailTemplates = () => {
  return (
    <Box>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Edit Email Templates</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <EditEmailTemplates />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Create Email Template</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CreateEmailTemplate />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
